import httpService from '@/modules/common/services/httpService';

const baseRoute = '/platform/v1/payment/packages';

const fetchPackages = async (page = 1, perPage = 25) => httpService.get(baseRoute, {
  page,
  include_items: true,
  active_only: true,
  per_page: perPage,
}).then((res) => res.data?.data?.packages);

const fetchPackageByUid = async (uid) => httpService.get(`${baseRoute}/${uid}`, {
  include_items: true,
}).then((res) => res.data?.data?.package);

export default {
  fetchPackages,
  fetchPackageByUid,
};
